'use client';
import styled from 'styled-components';

export const StyledMealPrepModal = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${props => props.theme.spacing(7)};
  @media ${props => props.theme.laptop} {
    padding: 0;
  }
`;
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${props => props.theme.spacing()};
  @media ${props => props.theme.laptop} {
    flex-direction: row;
  }
`;

export const Section = styled.div`
  width: 100%;
  padding: ${props => props.theme.spacing(3, 0)};
  &:not(:last-child) {
    border-bottom: 2px solid rgba(166, 153, 145, 0.5);
  }
  @media ${props => props.theme.laptop} {
    padding-top: 0;
    &:not(:last-child) {
      border-bottom: 0;
      padding: ${props => props.theme.spacing(0, 3)};
      border-right: 2px solid rgba(166, 153, 145, 0.5);
    }
  }
`;

export const SectionContent = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  padding-left: ${props => props.theme.spacing(2)};
  max-width: 345px;
  width: 100%;
`;

export const Name = styled.h2`
  ${({ theme }) => theme.typography.heading4}
  ${({ theme }) => theme.fontFamily.base}
  text-transform: capitalize;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const StrikeThroughPrice = styled.span`
  ${({ theme }) => theme.typography.body}
  ${({ theme }) => theme.fontFamily.base}
  margin-right: ${({ theme }) => theme.spacing(2)};
  text-decoration-line: line-through;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.status.successPrimary};
`;

export const DisplayedPrice = styled.span`
  ${({ theme }) => theme.typography.bodyBold}
  ${({ theme }) => theme.fontFamily.base}
	margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.label}
  p,
  #text {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
  }
  margin-top: ${props => props.theme.spacing(1)};
`;

export const PricesContainer = styled.div``;
